import React from 'react';
import { useDispatch } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';

import { notification } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { ButtonSmallIcon, dialogFunction } from 'common/components';

import { useCheckDisabledMasterAplBtn } from '../../sections/product-apl/hooks';

import {
  toggleReloadGridApl,
  resetReloadGridApl,
} from 'pages/branded-products-apl/controllers/actions';

import { deleteApl } from 'services/apl';

import { sleep } from 'utils/delay';

import Messages from 'i18n/messages/common';
import { MASTER_APL_NAME } from '../../sections/product-apl/constants';

const DeleteAplControl = ({ selectedItems }) => {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  const isDisabledMasterAplBtn = useCheckDisabledMasterAplBtn({
    ...selectedItems?.[0],
    companyId: selectedItems?.[0]?.ownerCompanyId,
  });

  const checkDisabledDeleteMasterAplBtn = () => {
    return isDisabledMasterAplBtn;
  };

  const checkDisabledDeleteNormalAplBtn = () => {
    return selectedItems?.some((item) => !item?.isOwner);
  };

  const disableDeleteAplBtn = () => {
    if (!selectedItems?.length) return true;

    const isMasterAPL = selectedItems.find(
      (item) => item.aplName === MASTER_APL_NAME
    );
    if (isMasterAPL) return checkDisabledDeleteMasterAplBtn();
    else return checkDisabledDeleteNormalAplBtn();
  };

  const isDisabled = disableDeleteAplBtn();

  const confirmDeleteAPL = () => {
    dialogFunction({
      type: 'warn',
      content: 'Are you sure you want to delete the APL(s)?',
      okText: 'Delete',
      okButtonProps: {
        type: 'danger',
      },
      onOk: handleDeleteAPL,
    });
  };

  const handleDeleteAPL = async () => {
    try {
      const aplIdList = selectedItems.map((item) => item.id);

      const response = await deleteApl({
        aplIds: aplIdList,
      });

      const { isSuccess, message } = response;
      if (isSuccess) {
        await sleep(1000);
        notification.success({
          message: 'Delete APL successfully!',
        });

        dispatch(toggleReloadGridApl());
        queryClient.invalidateQueries({
          queryKey: ['apl'],
        });
      } else {
        notification.error({
          message: message || 'Cannot delete APL!',
        });
      }
    } catch (error) {
      notification.error({ message: error || 'Cannot delete APL!' });
    } finally {
      await sleep(200);
      dispatch(resetReloadGridApl());
    }
  };

  return (
    <ButtonSmallIcon
      icon={<DeleteOutlined />}
      label={Messages.deleteAPLBtn}
      onClick={confirmDeleteAPL}
      disabled={isDisabled}
      className='button-item-dropdown'
    />
  );
};

export default DeleteAplControl;
